export default "__VITE_ASSET__Dj57mCvF__"